<template>
    <div v-if="activeClient" class="pa-5 compact-form">
        <div v-for="(item, index) in activeClient.codes" :key="item.id">
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Code" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.code"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                        @input="updateCodeField($event, 'code', index)"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Partner" | t }}</v-col>
                <v-col cols="6">
                    <v-select
                        :items="partners"
                        :value="item.partner"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                        placeholder="Partners"
                        @input="updateCodeField($event, 'partner', index)"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Shop" | t }}</v-col>
                <v-col cols="6" class="pa-0">
                    <v-autocomplete
                        :value="item.shop_id"
                        @change="updateCodeField($event, 'shop_id', index)"
                        :items="shops"
                        :loading="isLoading"
                        :placeholder="'Start typing to Search' | t"
                        color="bal-red"
                        dense
                        hide-no-data
                        hide-selected
                        item-text="name"
                        item-value="id"
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row class="mr-2" justify="end" no-gutters>
                <v-btn class="px-2" color="bal-red" dark @click.stop="deleteCode(index)">
                    <v-icon>delete</v-icon>
                    {{ "Delete" | t }}
                </v-btn>
            </v-row>
            <v-divider class="my-2" />
        </div>
        <v-btn class="px-2 ml-2" color="bal-red" dark style="min-width: 0;" @click.stop="addNewCode">
            <v-icon>add</v-icon>
            <span>{{ "Add new" | t }}</span>
        </v-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";

export default {
    name: "client-codes-edit-tab",
    data() {
        return {
            partners: ["odoo", "old_balsnack", "eugesta", "smarten"],
            isLoading: false,
            shop: null
        };
    },
    computed: {
        ...mapState("ClientStore", ["activeClient"]),
        ...mapState(["shops"])
    },
    methods: {
        updateCodeField(value, field, index) {
            Store.commit("ClientStore/updateActiveClientCodeProperty", {
                prop: field,
                value: value,
                index: index
            });
        },
        addNewCode() {
            Store.commit("ClientStore/addNewClientCode");
        },
        deleteCode(index) {
            if (confirm("Are you sure you want to delete this code?")) {
                Store.commit("ClientStore/deleteClientCode", index);
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: grey;
}
</style>
